import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
    Inject,
    Injectable,
    Optional,
    PLATFORM_ID,
    SkipSelf
} from '@angular/core';
import { environment } from '@environments/environment';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
/* import { PixelService } from 'ngx-pixel'; */

@Injectable({
    providedIn: 'root'
})
export class CheckoutService {
    constructor(
        @Inject(PLATFORM_ID)
        private platformId: any,
        private http: HttpClient,
        /* @SkipSelf() @Optional() private pixel: PixelService, */
        private $gaService: GoogleAnalyticsService
    ) { }

    orderDataSubject: BehaviorSubject<any> = new BehaviorSubject(null);
    orderData$ = this.orderDataSubject.asObservable();

    setData(data) {
        this.orderDataSubject.next(data);
    }

    getCheckoutData(type, _id,params) {
        return this.http.post<any>(`${environment.apiUrl}/checkout/${type}/${_id}`, params);
    }

    checkout(params, type, _id) {
        return this.http.post<any>(`${environment.apiUrl}/checkout/${type}/submit/${_id}`, params);
    }

    update(params, type, _id) {
        return this.http.post<any>(`${environment.apiUrl}/checkout/${type}/update/${_id}`, params);
    }

    getSuccessData(params) {
        return this.http.get<any>(`${environment.apiUrl}/checkout/${params.type}/success/${params.id}`);
    }

    invoice(params) {
        return this.http.get<any>(`${environment.apiUrl}/checkout/${params.type}/invoice/${params.id}`);
    }
}
